import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import {
    Route, Switch,
} from 'react-router-dom';

import urls from '../../app/urls';
import { Loading, PageNotFound } from '../../youwell-common/components';

import LoadProgramDetails from '../inside/components/LoadProgramDetails';
import LoadStudentProgram from './components/LoadStudentProgram';
import Layout from '../outside/components/Layout';
import Home from './Home';
import Skill from './Skill';
import Task from './Task';

class Index extends React.Component {
    render() {
        const {
            appConfig, loading,
        } = this.props;

        return (
            <Layout
                headerProps={{
                    hideHeaderLinks: true,
                    headerPageTitle: this.props.translate('studentLogin.title'),
                }}
                fullPage
            >
                <Loading loading={loading} />
                <LoadProgramDetails programId={appConfig?.vimoProgramId} />
                <Route path={`${urls.studentCode.home}/:code`} component={LoadStudentProgram} />

                <Switch>
                    <Route exact path={`${urls.studentCode.home}/:code`} component={Home} />
                    <Route exact path={`${urls.studentCode.home}/:code/${urls.studentCode.parts.skill}/:skillId`} component={Skill} />
                    <Route path={`${urls.studentCode.home}/:code/${urls.studentCode.parts.skill}/:skillId/${urls.studentCode.parts.task}/:taskId`} component={Task} />
                    <Route component={PageNotFound} />
                </Switch>
            </Layout>
        );
    }
}

Index.propTypes = {
    translate: PropTypes.func.isRequired,
    appConfig: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    loading: state.studentCodeStore.loading,
    appConfig: state.pageSettings.appConfig,
});

export default connect(mapStateToProps)(Index);
